import {throwError} from './utils';

/**
 * Create dom element from inputted options
 * @param {string} element tag name
 * @param {Object} dom attributes object
 * @returns {Object}
 */
export function createElement(tagName, options) {
    let element;
    if (tagName === 'svg') {
        element = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        for (const key in options) {
            element.setAttribute(key, options[key]);
        }
    } else {
        element = document.createElement(tagName);
        for (const key in options) {
            element[key] = options[key];
        }
    }

    return element;
}

/**
 * Insert child element into container element dom
 * @param {Object} container dom element
 * @param {Object} child dom element
 * @returns {Object}
 */
export function renderElement(containerElement, element) {
    while (containerElement.firstChild) {
        containerElement.removeChild(containerElement.lastChild);
    }

    return containerElement.appendChild(element);
}

/**
 * Changes dom element attributes
 * @param {Object} container dom element
 * @param {Object} dom attributes object
 * @returns {Object}
 */
export function changeElementAttributes(element, attributes) {
    for (const key in attributes) {
        element[key] = attributes[key];
    }

    return element;
}

/**
 * Checks if param is dom element, if not gets it from dom by id name
 * @param {string|Object} dom element or element id
 * @returns {Object}
 */
export function getElement(element) {
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }

    if (!element) {
        throwError('Unknown dom element.');
    }

    return element;
}

/**
 * Remove child element from container element dom
 * @param {Object} container dom element
 * @param {Object} child dom element
 * @returns {Object}
 */
export function removeElement(containerElement, element) {
    try  {
        containerElement.removeChild(element);
    } catch (e) {
        throwError('Unknown element to remove.');
    }

    return containerElement;
}
